import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/templates/AppLayout/AppLayout';
import { AuthLayout } from '../components/templates/AuthLayout';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/Sidebar';
import { PageContent } from '../components/templates/PageContent/PageContent';
import { PageHeader } from '../components/templates/PageHeader/PageHeader';
import { Button } from '../components/atoms/Button/Button';
import { Stack } from '../components/atoms/Stack/Stack';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from '../i18n/useTranslation';

/**
 * 404 for every unknown URL (route `path="*"`). Signed-in users see it in the
 * app shell with a way back to the dashboard; signed-out visitors get the
 * public layout with a link to the sign-in page.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useAuth();

  if (!state.isAuthenticated) {
    return (
      <AuthLayout title={t('notFound.title')} subtitle={t('notFound.description')}>
        <Stack gap="4">
          <Button variant="primary" fullWidth onClick={() => navigate('/login')}>
            {t('notFound.toLogin')}
          </Button>
        </Stack>
      </AuthLayout>
    );
  }

  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="narrow">
          <PageHeader
            title={t('notFound.title')}
            description={t('notFound.description')}
            actions={
              <Button variant="primary" onClick={() => navigate('/dashboard')}>
                {t('notFound.toDashboard')}
              </Button>
            }
          />
        </PageContent>
      }
    />
  );
}

export default NotFoundPage;
